"use client";
import Link from "next/link";
import LeftArrowFull from "assets/imgs/left-arrow-full.svg";

const formatter = new Intl.DateTimeFormat("en-US", {
	year: "numeric",
	month: "2-digit",
	day: "2-digit",
}).format;

export default function ResourcesHeader({
	date,
	showReturnLink,
	returnLink,
}: {
	date: string;
	showReturnLink?: boolean;
	returnLink?: string;
}) {
	const dateFormatter = (d: string): string => {
		const date = new Date(d);
		return formatter(date);
	};

	return (
		<div>
			{showReturnLink && (
				<div className="resource-return">
					<Link passHref href={returnLink ?? "/resources"}>
						<LeftArrowFull /> Back to Resources
					</Link>
				</div>
			)}
			<div className="resource-info">
				<p className="resource-info-date xs">Posted {dateFormatter(date)}</p>
			</div>
		</div>
	);
}
